module.exports = __webpack_public_path__ + "img/1.a51f35b2.png";